import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_LEGACY_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { GithubSyncDialogData } from '@mode/github/contract';
import { GithubSyncDialogFacade } from '@mode/github/domain';

@Component({
  selector: 'mode-github-sync-modal',
  templateUrl: './github-sync-modal.component.html',
  styleUrls: ['./github-sync-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GithubSyncModalComponent {
  syncToGithubForm = new FormGroup({
    commitMessage: new FormControl(this.data.defaultCommitMessage, Validators.required),
  });

  constructor(
    @Inject(MAT_LEGACY_DIALOG_DATA) private data: GithubSyncDialogData,
    private githubFacade: GithubSyncDialogFacade
  ) {}

  pushChanges(): void {
    const commitMessage = this.syncToGithubForm.controls.commitMessage.value;
    if (commitMessage) {
      this.githubFacade.dispatch(
        GithubSyncDialogFacade.Actions.githubSyncDialogChangesPushed({
          dialogData: this.data,
          commitMessage,
        })
      );
    }
  }
}
